var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":"bhGray6"}},[_c('span',{class:("dot-status__dot dot-status__dot--" + _vm.statusClass)}),_vm._v("\n  "+_vm._s(_vm.statusName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }